import type { CSSProperties } from 'react';
import './HintLadder.css';

export interface Hint {
  title?: string;
  label: string;
  cost?: number;
}

export interface HintLadderProps {
  hints: ReadonlyArray<Hint | string>;
  /** How many rungs are revealed. */
  revealed?: number;
  /** Called with the new revealed count when the student opens the next rung. */
  onReveal?: (next: number) => void;
  style?: CSSProperties;
}

export function HintLadder({ hints, revealed = 0, onReveal, style }: HintLadderProps) {
  return (
    <div className="uc-hl" style={style}>
      {hints.map((h, i) => {
        const isOpen = i < revealed;
        const isNext = i === revealed;
        const locked = !isOpen && !isNext;
        const label = typeof h === 'string' ? h : h.label;
        const cost = typeof h === 'object' ? h.cost : undefined;
        const title = typeof h === 'object' ? (h.title ?? `Hint ${i + 1}`) : `Hint ${i + 1}`;
        return (
          <div
            key={i}
            className={`uc-hl__rung${isOpen ? ' uc-hl__rung--open' : ''}${locked ? ' uc-hl__rung--locked' : ''}`}
          >
            <button
              className="uc-hl__btn"
              disabled={locked}
              aria-expanded={isOpen}
              onClick={() => !isOpen && isNext && onReveal?.(i + 1)}
            >
              <span className="uc-hl__n">{String(i + 1).padStart(2, '0')}</span>
              <span className="uc-hl__lbl">
                {isOpen ? title : isNext ? 'Reveal next hint' : 'Locked'}
              </span>
              {!isOpen && cost != null && <span className="uc-hl__cost">−{cost}</span>}
            </button>
            {isOpen && <div className="uc-hl__text">{label}</div>}
          </div>
        );
      })}
    </div>
  );
}
